<template>
    <div class="tablePage">
        <el-table
            stripe
            v-loading="loading"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="headCellStyle"
            :height="tableHeight"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="50" stripe />

            <el-table-column v-if="isSys" prop="scopeName" :label="$t('public.table_scope')" show-overflow-tooltip />
            <el-table-column prop="mac" label="mac" show-overflow-tooltip>
                <template #default="{ row }">
                    <i v-icon:theme="['gatewayTypeConvert', row.type]"></i>
<!--                    <i v-icon:theme="['equiStatusConvert', row.status]"></i>-->
                    <el-popover placement="top-start" width="auto" trigger="hover">
                        <v-popoer :rowData="row" :typeWay="$attrs.sensorWay" />
                        <span slot="reference">
                            <span>{{ row.mac }}</span>
                        </span>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" :label="$t('public.table_create_time')" show-overflow-tooltip>
                <template #default="{ row }">
                    <span>{{ $timetransition(row.createTime) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="description" :label="$t('public.table_desc')" show-overflow-tooltip></el-table-column>
            <el-table-column prop="optare" fixed='right' :label="$t('public.table_operation')" width="160" align="center">
                <template #default="{ row }">
                    <el-button type="text" size="small" v-for="item in optareBtn" :key="item.id" :title="$t(item.title)" :icon="item.icon" @click="handle(item.method, row)"></el-button>
                    <!-- v-has="item.vHas" -->
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import prover from '../components/Proper.vue'
import { gatewayTypeConvert, equiStatusConvert, configStatusConvert, carrierTypeConvert } from '@/utils/convert'
export default {
  props: ['loading', 'tableData'],
  computed: {
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      const currentUser = this.$store.getters.userInfo.scope
      if (currentUser.sysScope && currentUser.sysAdmin) {
        // 系统管理员
        return 'isSysAdmin'
      } else if (currentUser.sysScope && !currentUser.sysAdmin) {
        // 系统非管理员
        return 'isSysNoAdmin'
      } else if ((!currentUser.sysScope && currentUser.scopeAdmin) || currentUser.type === 2) {
        // 非系统管理员 以及代理角色  代理角色是迭代7的需求添加
        return 'noSysIsAdmin'
      } else {
        // 非系统非管理员
        return 'noSysNoAdmin'
      }
    }
  },
  components: {
    'v-popoer': prover
  },
  data () {
    return {
      gatewayTypeConvert,
      equiStatusConvert,
      configStatusConvert,
      carrierTypeConvert,
      tableHeight: '100%',
      optareBtn: [
        {
          id: 1,
          title: $t('public.edit'),
          icon: 'el-icon-edit-outline',
          vHas: [],
          method: 'editRowFn'
        },
        {
          id: 2,
          title: 'public.details',
          icon: 'el-icon-tickets',
          vHas: [],
          method: 'detailFn'
        },
        {
          id: 3,
          title: $t('public.tbopt_delete'),
          icon: 'el-icon-delete',
          vHas: [],
          method: 'delRowFn'
        }
        // {
        //     id: 3,
        //     title: $t('public.config'),
        //     icon: 'el-icon-setting',
        //     vHas: [],
        //     method: 'configFn'
        // },

      ],
      isSys: true
    }
  },

  mounted () {
    if (this.sysAdmin === 'noSysIsAdmin' || this.sysAdmin === 'noSysNoAdmin') {
      this.isSys = false
    }
  },

  methods: {
    handleSelectionChange (row) {
      this.$emit('choozeTable', row)
    },
    handle (method, row) {
      this.$emit(method, row)
    }
  }
}
</script>

<style lang="scss" scoped>
.tablePage {
    height: calc(100% - 60px);
}
</style>
